import React from 'react';
import styled, { keyframes } from 'styled-components';
import colors from '../ui/colors';

const loaderRotation = keyframes`
	from {
		transform: translate(-50%,-50%) rotate(0deg);
	}
	to {
		transform: translate(-50%,-50%) rotate(360deg);
	}
`;

const loaderDashoffset = keyframes`
  from {
		stroke-dashoffset: 50.272552490234375;
	}
	to {
		stroke-dashoffset: -50.272552490234375;
	}
`;

const LoaderContainer = styled.div`
  ${props => !props.isLoading && (`
    display: none;
  `)}
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255,255,255,.5);
  z-index: 1;
`;

const LoaderWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 96px;
  height: 96px;
  animation-name: ${loaderRotation};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const LoaderSVG = styled.svg`
  width: 96px;
  height: 96px;
  fill: none;
  stroke: ${colors.BRAND_GREEN};
  stroke-width: 1px;
  stroke-dashoffset: 0;
  stroke-dasharray: 50.272552490234375 50.272552490234375;

  animation-name: ${loaderDashoffset};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const BlockingLoader = ({isLoading}) => {
  return (
    <LoaderContainer isLoading={isLoading}>
      <LoaderWrapper>
        <LoaderSVG viewBox="-4 -4 24 24">
          <circle cx="8" cy="8" r="8"></circle>
        </LoaderSVG>
      </LoaderWrapper>
    </LoaderContainer>
  );
}

export {
  BlockingLoader,
  LoaderSVG,
  LoaderWrapper
};


// WEBPACK FOOTER //
// ./src/modules/common/components/loader/BlockingLoader.js